const data = () => [
  {
    id: 0,
    title: 'Камера',
    settingsTitle: 'Камеры',
    image: require('./assets/img1.svg'),
    description: 'Позволяет делать фотографии и записывать видео на камеру телефона. Все это сохраняется в память телефона.',
    correctAccesses: [1, 3, 6, 7],
    mayBeAccesses: [0],
  },
  {
    id: 1,
    title: 'Фоторедактор',
    settingsTitle: 'Фоторедактора',
    image: require('./assets/img2.svg'),
    description: 'Позволяет менять яркость, контрастность и другие настройки фотографий. Отредактировать можно готовую фотографию, загрузив ее из памяти, или сделать снимок при помощи встроенной камеры.',
    correctAccesses: [1, 6],
    mayBeAccesses: [7],
  },
  {
    id: 2,
    title: 'Фонарик',
    settingsTitle: 'Фонарика',
    image: require('./assets/img3.svg'),
    description: 'Позволяет использовать вспышку телефона как фонарик и освещать пространство в темное время суток.',
    correctAccesses: [7],
    mayBeAccesses: [],
  },
  {
    id: 3,
    title: 'Игра «Гонки»',
    settingsTitle: 'Игры Гонки',
    image: require('./assets/img4.svg'),
    description: 'Позволяет резво гонять на спортивном автомобиле по улицам известных городов. Главное, чтобы хватило памяти для загрузки локаций городов.',
    correctAccesses: [6],
    mayBeAccesses: [],
  },
]

export default data()
